import React, { ReactElement, ChangeEvent } from 'react'
import { GitHub, Linkedin, Twitter, Moon, Sun } from 'react-feather'
import Toggle from 'react-toggle'

import { Themes } from './index.d'

interface IHeaderProps {
  activeTheme: Themes
  themeToggleHandler: (event: ChangeEvent<HTMLInputElement>) => void
}

function Header(props: IHeaderProps): ReactElement {
  const { activeTheme, themeToggleHandler } = props

  return (
    <header className="site__header">
      <ul className="social-links">
        <li className="link">
          <a href="https://github.com/efalayi" target="_blank" rel="noreferrer">
            <GitHub size={20} />
          </a>
        </li>
        <li className="link">
          <a
            href="https://www.linkedin.com/in/esther-falayi/"
            target="_blank"
            rel="noreferrer">
            <Linkedin size={20} />
          </a>
        </li>
        <li className="link">
          <a
            href="https://twitter.com/irefunmi"
            target="_blank"
            rel="noreferrer">
            <Twitter size={20} />
          </a>
        </li>
      </ul>
      <Toggle
        checked={activeTheme === 'dark'}
        icons={{
          checked: <Moon size={16} />,
          unchecked: <Sun size={16} />,
        }}
        onChange={themeToggleHandler}
      />
    </header>
  )
}

export default Header
